import { resolveDashboardUrl } from './resolveDashboardUrl';

export async function openWebAppPage(path: string): Promise<void> {
  const url = new URL(path, `${resolveDashboardUrl()}/`).toString();

  if (window.electronAPI?.shell) {
    const result = await window.electronAPI.shell.openExternal(url);

    if (!result.success) {
      throw new Error(result.error ?? `Unable to open ${url}`);
    }

    return;
  }

  window.open(url, '_blank', 'noopener,noreferrer');
}
